import { OfferingHeader } from "../index";
import React, { useState, useEffect } from "react";
import { useAppStore } from "../../data/AppStore";
import { logger } from "../../utilities";
import OfferingContent from "./OfferingContent";
import { useNavigate } from "react-router-dom";
import { shallow } from "zustand/shallow";
import OfferingContentNavigation from "./OfferingContentNavigation";
import "./OfferingContent.scss";

const LOG_PREFIX = "[OfferingContentContainer.js]";

const OfferingContentContainer = ({ offering, toggleModal }) => {
  const [state, _setState] = useState({
    buying: false,
    immediateChildren: [],
    relation: null,
  });
  const setState = (newState) => _setState(Object.assign({}, state, newState));
  const { buying, relation, immediateChildren } = state;
  const [OFFERINGS, RELATIONS, CART, rectifyCART] = useAppStore(
    (state) => [
      state.OFFERINGS,
      state.RELATIONS,
      state.CART,
      state.rectifyCART,
    ],
    shallow
  );
  const navigate = useNavigate();

  useEffect(() => {
    // Only process if RELATIONS and OFFERINGS are ready
    if (!RELATIONS || !Array.isArray(RELATIONS) || !Array.isArray(OFFERINGS)) {
      setState({ immediateChildren: [], relation: null });
      return;
    }

    const flatRelations = [
      ...new Set([
        ...RELATIONS,
        ...RELATIONS.map((r) => r.children).flat(),
        ...RELATIONS.map((r) =>
          r.children.map((c) => c.children).flat()
        ).flat(),
      ]),
    ];
    const relation = flatRelations.find((r) => r.id === offering.id);
    const immediateChildren = relation
      ? relation.children.map((c) => OFFERINGS.find((o) => c.id === o.id))
      : [];
    setState({ immediateChildren, relation });
  }, [offering, RELATIONS, OFFERINGS]);

  const addToCart = (offering, amount = 1) => {
    logger.debug(LOG_PREFIX, ".addToCart()", { state, offering });
    setState({ buying: true });
    CART.quantity[offering.id] = CART.quantity[offering.id]
      ? parseInt(CART.quantity[offering.id]) + parseInt(amount)
      : parseInt(amount);
    rectifyCART(CART);
    setState({ buying: false });
  };

  return (
    <div className={"OfferingContentContainer"}>
      <OfferingHeader
        cart={CART}
        offering={offering}
        viewCart={() => navigate(`/cart/`, { replace: true })}
        toggleEmailModal={toggleModal}
      />

      <OfferingContent
        offering={offering}
        buying={buying}
        relation={relation}
        immediateChildren={immediateChildren}
        cartCallback={addToCart}
      />

      <OfferingContentNavigation
        showButton={!(immediateChildren.length >= 1)}
        offering={offering}
        buying={buying}
        relation={relation}
        cartCallback={addToCart}
      />
    </div>
  );
};

export default OfferingContentContainer;
